import _ from 'lodash';
import {
    IcatuCapPurchaseSnapshot,
    IcatuCapRiskSiteSnapshot,
} from '../../models/IcatuCap';
import api from '../api';
import { getBackVersion } from '../../config';

type GetCapResponse = Omit<
    IcatuCapPurchaseSnapshot,
    'riskSite' | 'propertyType' | 'propertyPurpose'
> & {
    riskSite: IcatuCapRiskSiteSnapshot &
        Pick<IcatuCapPurchaseSnapshot, 'propertyType' | 'propertyPurpose'>;
};

const getCap = (id: string): Promise<IcatuCapPurchaseSnapshot> =>
    api
        .request<GetCapResponse>({
            method: 'GET',
            url: `${getBackVersion()}/agent/cap/${id}`,
        })
        .then(response => ({
            ...response,
            propertyType: response.riskSite?.propertyType,
            propertyPurpose: response.riskSite?.propertyPurpose,
            riskSite: response?.riskSite?.streetNumber
                ? _.omit(response.riskSite, ['propertyType', 'propertyPurpose'])
                : null,
        }));

export { getCap };
